export default "__VITE_ASSET__B7UcbWpA__"